import { FORM_TYPES } from "../../../../SharedStores/Form/formStore";
import { PROJECT_FORM_TYPES } from "../projectFormStore";

export function getElementsFromDataFieldId(rootGetters, dataFieldId) {
    const projectElement = rootGetters[PROJECT_FORM_TYPES.getters.projectElementFromDataFieldId](dataFieldId);
    const formElement = rootGetters[FORM_TYPES.getters.elementFromId](projectElement.FormElementId);
    return { projectElement, formElement };
}
